<template>
    <div class="lista">
        <div class="titulo">{{val.titulo}}</div>
        <div class="search-bar">
            <search-bar/>
        </div>
        <div class="list-wraper">
            <ul class="lista">
                <li v-for="item in val.items">
                    <label class="check-box">
                        <input type="checkbox" v-model="item.checked"/>
                        <span class="titulo-item" v-text="item.titulo"/>
                        <span class="checkmark" />
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ['val'],
}
</script>

<style lang="scss">
// @import "../../../styles.scss";

.lista {
    background-color: $sovis-white;
    > .titulo {
        padding: 25px 15px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        font-size: 12px;
        color: $text-color;
    }
}

.list-wraper {
    height: 300px;
    overflow-y: auto;
    padding-bottom: 5px;
    margin-right: 15px;
    &::-webkit-scrollbar {
        width: 7px;
    }

    &::-webkit-scrollbar-track {
        background: $darker-bg-color;
        border-radius: 1rem;
    }

    &::-webkit-scrollbar-thumb {
        background: $sb-background;
        border-radius: 1rem;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: $light-gray-color;
    }
}

.lista {
    padding: 5px 0 5px 0;
    margin-left: 15px;
    li {
        list-style: none;
        padding: 14px 0 14px 24px;
        label{
            height: 100%;
            margin: 0;
        }
        &:hover {
            background: $darker-bg-color;
            border-radius: 5px 5px 0px 0px;
        }
    }
}

.search-bar {
    padding: 0 15px;
}

.check-box {
    color: $darker-gray-color;
    font-weight: 600;
}

.checkmark {
    left: 0;
}

.titulo-item {
    margin-left: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 12px;
    color: $light-gray-color;
}

</style>
